// Custom components
import { TextField } from '@mui/material';
import React from 'react';

function InputField(props) {
  const {
    multiline,
    label,
    id,
    extra,
    type,
    placeholder,
    variant,
    state,
    disabled,
    name,
    register,
    error,
    required,
    value,
    defaultValue,
    onChange,
    autoComplete,
    min,
    sx,
    color,
    dataCy,
  } = props;

  return register ? (
    <div>
      <TextField
        label={label}
        sx={{
          '& .MuiInputLabel-root': { color: color ? color : '' },
          '& .MuiInputLabel-root.Mui-focused': { color: color ? color : 'green' },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: error ? 'red' : color ? color : '',
            },
            '&:hover fieldset': {
              borderColor: error ? 'red' : color ? color : 'green',
            },
            '&.Mui-focused fieldset': {
              borderColor: color ? color : 'green',
            },
          },
          '& .MuiInputBase-input': { color: color ? color : '' },
        }}
        readOnly={disabled}
        className="shadow-sm"
        fullWidth
        classes={extra}
        step="any"
        min={min}
        {...register(`${name}`)}
        disabled={disabled}
        type={type}
        id={id}
        value={value}
        name={name}
        multiline={multiline}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete == false ? 'new-password' : ''}
      />
      <p data-cy={`${dataCy}-error`} className="p-1 text-red-600">
        {error && error}
      </p>
    </div>
  ) : (
    <div className="flex flex-col flex-1">
      <TextField
        sx={{
          '& .MuiInputLabel-root': { color: color ? color : '' },
          '& .MuiInputLabel-root.Mui-focused': { color: error ? 'red' : color ? color : 'green' },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: color ? color : '',
            },
            '&:hover fieldset': {
              borderColor: error ? 'red' : color ? color : 'green',
            },
            '&.Mui-focused fieldset': {
              borderColor: error ? 'red' : color ? color : 'green',
            },
          },
          '& .MuiInputBase-input': { color: color ? color : '' },
        }}
        label={label}
        error={error ? true : false}
        fullWidth
        multiline={multiline}
        readOnly={disabled}
        type={type}
        id={id}
        value={value}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        className="shadow-sm"
      />
      <p data-cy={`${dataCy}-error`} className="p-1 text-red-600">
        {error && error}
      </p>
    </div>
  );
}

export default InputField;
